// extracted by mini-css-extract-plugin
export default {"contactsLinks":"Contacts_contactsLinks__XDpCd","contactItem":"Contacts_contactItem__hF3yn","contactIcon":"Contacts_contactIcon__WtFYZ"};